import React, { useContext } from "react";
import HyperLogo from "../../Images/HyperLogo.png";
import styled from "styled-components";
import { UserContext } from "../../contexts/UserContext";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { GoCalendar } from "react-icons/go";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import { Button } from "../../Theme/Hyper";
const Main = styled.div`
  height: 35px;
  background-color: #202731;
  z-index: 1000;
  position: -webkit-sticky;
  position: sticky;
  box-shadow: 0px 4px 12px -20px rgb(0 0 0 / 20%),
    0px 8px 20px 2px rgb(0 0 0 / 14%), 0 9px 46px 8px rgb(0 0 0 / 12%);
  display: flex;
  align-items: center;
  border-bottom: 1px solid #030304;
`;

const Left = styled.div`
  width: 40%;
  padding-left: 1em;
  display: flex;
`;

const Right = styled.div`
  width: 40%;
  padding-right: 1em;
  display: flex;
  align-items: center;
`;

const Profile = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  margin-left: auto;
  margin-right: auto;
  height: 50%;
`;
export default function NavBarMobile(view) {
  const { user, signOut } = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  let { gameID } = useParams();
  return (
    <header className="sticky top-0 z-30 flex h-[5vh] items-center justify-between border-b border-outline-ghost bg-section/95 px-8 backdrop-blur">
      <div div className="flex items-start ml-auto w-[40%] justify-start">
      <button
        type="button"
        className="grid h-11 w-11 place-items-center rounded-full bg-surface text-on-surface-variant transition hover:bg-surface-high hover:text-on-surface"
          onClick={() => {
              history.push({
                pathname: "/comms",
              });
          }}
        >
          <GoCalendar />
        </button>
      </div>
      <Logo src={HyperLogo} alt="Hyper Logo" />
      <div className="flex items-end ml-auto w-[40%] justify-end">

        {user && (
          <Profile>
          <button
            type="button"
            onClick={() => {
              signOut();
            }}
            className="ml-auto rounded-xl bg-surface-high px-4 py-2 text-xs font-600 uppercase tracking-[0.2em] text-on-surface-variant transition hover:bg-surface-highest hover:text-on-surface"
          >
            Sign Out
          </button>
          </Profile>
        )}
      </div>
    </header>
  );
}
